import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import ListSubheader from '@mui/material/ListSubheader'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../common'
import { ExpenseType } from './DetailsExpenseRow'
import { formatCurrency } from '../../core/utils/NumberFormatting'

interface DetailsExpenseHeaderProps {
  total: number
  type: ExpenseType
}

const DetailsExpenseHeader: React.FC<DetailsExpenseHeaderProps> = ({ total, type }) => {
  const { cashflow: customCopy } = useGlobalCopyStore()

  return (
    <>
      <ListSubheader
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.highlight',
          display: 'flex',
          justifyContent: 'space-between',
          pb: 4,
          pt: 12,
          px: 24,
        }}
      >
        <Text bold={true} sx={{ fontSize: 12 }}>
          {type === ExpenseType.EXPENSE ? customCopy.expenses : customCopy.income}
        </Text>
        <Text bold={true} sx={{ fontSize: 13 }}>
          {type === ExpenseType.EXPENSE ? '-' : '+'}
          {formatCurrency(total, '0,0.00')}
        </Text>
      </ListSubheader>
      <Divider />
    </>
  )
}

export default observer(DetailsExpenseHeader)
